<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener('DOMContentLoaded', function() {
  // Funcionalidad para ambos acordeones
  document.querySelectorAll('.bank-accordion, .payment-accordion').forEach(accordion => {
    const accordionHeader = accordion.querySelector('.accordion-header');
    const accordionContent = accordion.querySelector('.accordion-content');

    // Inicializar estado
    accordionHeader.classList.add('active');
    accordionContent.classList.add('active');

    // Manejar clic
    accordionHeader.addEventListener('click', function() {
      this.classList.toggle('active');
      accordionContent.classList.toggle('active');
    });
  });

  // Funcionalidad de tabs para ambos acordeones
  document.querySelectorAll('.bank-accordion, .payment-accordion').forEach(accordion => {
    const tabs = accordion.querySelectorAll('.tab');
    const panels = accordion.querySelectorAll('.panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        // Remover clase activa de todos los tabs y panels dentro de este acordeon
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        
        // Activar tab y panel correspondiente
        this.classList.add('active');
        const panelId = this.dataset.panel;
        accordion.querySelector(`#${panelId}`).classList.add('active');
      });
    });
  });

  // Navegación del carrusel para ambos acordeones
  document.querySelectorAll('.bank-accordion, .payment-accordion').forEach(accordion => {
    const tabsContainer = accordion.querySelector('.tabs-container');
    const prevButton = accordion.querySelector('.prev');
    const nextButton = accordion.querySelector('.next');

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => {
        tabsContainer.scrollBy({ left: -200, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        tabsContainer.scrollBy({ left: 200, behavior: 'smooth' });
      });
    }
  });

  // Modal functionality (se mantiene igual)
  const modal = document.querySelector('.financing-modal');
  const triggers = document.querySelectorAll('.know-more-trigger');
  const closeButtons = document.querySelectorAll('.modal-close, .modal-overlay');

  // Abrir modal
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
    });
  });

  // Cerrar modal
  closeButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
    });
  });

  // Cerrar con ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'block') {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
    }
  });
});


/*
function trackBotonCreditoNequi() {
    gtag('event', 'click_boton_credito_nequi', {
      'event_category': 'interacciones',
      'event_label': 'boton_nequi_externo',
      'value': 1
    });

    // Esperar brevemente para que el evento se registre
    setTimeout(() => {
      window.location.href = 'https://redirect.nequi.co/credits?utm_source=refurbi_homepage';
    }, 300); // 300 ms suele ser suficiente
}


document.addEventListener("DOMContentLoaded", function () {
    const boton = document.querySelector(".boton-tercero");

    if (boton) {
      boton.addEventListener("click", function () {
        gtag('event', 'clic_boton_nequi', {
          'event_category': 'interacciones',
          'event_label': 'redirect.nequi.co/credits',
          'value': 1
        });
      });
    }
});
*/


